
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import veeno from "veeno";
import "nouislider/distribute/nouislider.min.css";
export default {
  components: { dialogCloseBtn, veeno },
  props: {
    dialog: false
  },

  data() {
    return {
      loading: false,
      timings: [],
      seasons: ["Winter", "Spring", "Summer", "Fall"],
      icons: ["mdi-snowflake", "mdi-leaf", "mdi-fire", "mdi-water"]
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    timingsProp() {
      return [...this.timings];
    }
  },
  watch: {},
  mounted() {
    this.timings = [];
    this.locationDetails.location_timing.forEach(
      ((element, index) => {
        if (index == 0) {
          this.timings.push(
            Number(this.getMinutesFromFormattedTime(element.start_time))
          );
        }
        this.timings.push(
          Number(this.getMinutesFromFormattedTime(element.end_time))
        );
      }).bind(this)
    );
  },
  methods: {
    ...mapActions("menu", ["updateTiming"]),
    ...mapActions("restaurant", ["getLocationDetails"]),
    season(val) {
      return this.icons[val];
    },
    handleSubmit() {
      this.loading = true;
      let restaurant_timing = [];
      this.$constants.Batches.BATCHES.forEach(
        ((batch, index) => {
          restaurant_timing.push({
            name: batch.value,
            start_time: this.getFormattedTimeFromMinute(this.timings[index]),
            end_time: this.getFormattedTimeFromMinute(this.timings[index + 1])
          });
        }).bind(this)
      );

      this.updateTiming({ restaurant: { restaurant_timing } })
        .then((res) => {
          this.getLocationDetails(false);
          this.$nuxt.$emit("show-toast", {
            text: "Timing updated successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("close-dialog");
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        });
    },
    sliderChange(val) {
      this.timings = val.unencoded.map((el) => {
        return Math.round(el);
      });
    }
  }
};
